import apiFetch from '../apiFetch'

export default async function (COMPort, type) {
  return apiFetch({server: `camara`, endPoint: 'bascula?port=' + COMPort + '&type=' + type, method: 'GET', body: null, credentials: 'omit', mode: 'cors'})
}